<template lang="pug">
.trainer-outer-wrapper(:class="'context-'+context")
  include Trainer.pug
</template>

<script>
import _ from 'underscore'
import slugify from '@/components/services/Slug'
import Contact from '@/components/Contact'
import TrainerDetailAddress from '@/components/trainer_detail_address/TrainerDetailAddress'
import TrainerLevel from '@/components/TrainerLevel'
import { mapState } from 'vuex'
import tooltipContent from './TrainerTooltip'
import Api from '@/components/services/Api'

export default {
  name: 'Trainer',
  components: {
    Contact,
    TrainerDetailAddress,
    TrainerLevel,
  },
  computed: _.extend(mapState(['context']), {
    fullname() {
      return this.trainer.first_name + ' ' + this.trainer.last_name
    },
    professionallink() {
      console.log(this.trainer)
      if (this.context == 'esreps') {
        return `esreps.org/e/${this.trainer.slug}`
      } else {
        return `www.repscolombia.org/e/${this.trainer.slug}`
      }
    },
  }),
  props: ['trainer', 'displayMode', 'view', 'hideCecs'],
  data() {
    return {
      actionImage: '',
      editEnabled: false,
      randomImage: null,
      tooltipContent,
      instagram: '',
      facebook: '',
      currentUrl: '',
      currentToken: '',
      plan: null,
    }
  },
  mounted() {
    let $rating = jQuery('.barrating-' + this.trainer.slug)
    let points = parseInt(`${this.trainer.points}`, 10)
    // min points 50 ==> 1
    // max points 390 ==> 5 (340 normalized)
    points -= 50 // base 1
    let ratio = 1 + (points / 340) * 4

    $rating.barrating({
      theme: 'bars-1to10',
      deselectable: false,
      readonly: true,
      initialRating: ratio,
    })
  },
  created() {
    let min = 1
    let max = 15
    let randomIntegerImage = Math.floor(Math.random() * (max - min + 1) + min)
    this.randomImage =
      '/static/img/avatar/avatar-perfil-' + randomIntegerImage + '.png'
    this.editEnabled = this.$route.name == 'DashboardProfile'

    if (this.editEnabled) {
      // ask for me service
      const _this = this

      Api.me(this.$store.state.token)
        .then(response => {
          const data = response.data
          _this.facebook = data.facebook
          _this.instagram = data.instagram
        })
        .catch(err => {})
    }

    // calculate the post url for the image
    this.currentUrl = `${window.location.href}`
    this.actionImage = `${Api.getApiUrl()}/esreps/file-partial-update-user/`
    this.currentToken = this.$store.state.token
    const plan = this.trainer.plan
    this.plan = plan
  },
  methods: {
    hasProfilePhoto() {
      return !_.isEmpty(
        this.trainer.profile_photo_path &&
          this.trainer.profile_photo_path.length
      )
    },
    saveInstagram() {
      const _this = this

      let partialData = {
        instagram: this.instagram,
      }

      Api.userPartialUpdate(partialData, this.$store.state.token)
        .then(response => {
          _this.$notify({
            group: 'esreps',
            title: 'Datos actualizados',
            type: 'success',
            text:
              'Se han actualizados los datos de la cuenta de Instagram correctamente en la base de datos',
          })
        })
        .catch(err => {})
    },
    saveFacebook() {
      const _this = this

      let partialData = {
        facebook: this.facebook,
      }

      Api.userPartialUpdate(partialData, this.$store.state.token)
        .then(response => {
          _this.$notify({
            group: 'esreps',
            title: 'Datos actualizados',
            type: 'success',
            text:
              'Se han actualizados los datos de la cuenta de Facebook correctamente en la base de datos',
          })
        })
        .catch(err => {})
    },
  },
}
</script>

<style scoped lang="scss">
@import '../variables';
@import '../variables_colreps';
@import '../variables_mexreps';

@import 'Trainer';

.context-colreps {
  @import 'TrainerColreps';
}

.context-mexreps {
  @import 'TrainerMexreps';
}
</style>



// WEBPACK FOOTER //
// src/components/Trainer.vue